import React from 'react';
import AccessibleIcon from '@mui/icons-material/Accessible';
import { usePxToVw } from '../hooks/usePxToVw';

const WheelchairToggle = ({ settings, isActive, onClick }) => {
  const { pxToVw } = usePxToVw();

  if (!settings || !settings.enabled) {
    return null;
  }

  const getButtonStyle = () => {
    const bgColor = settings.backgroundColor || '#FFFFFF';
    const bgOpacity = (settings.backgroundOpacity ?? 90) / 100;
    const r = parseInt(bgColor.slice(1, 3), 16);
    const g = parseInt(bgColor.slice(3, 5), 16);
    const b = parseInt(bgColor.slice(5, 7), 16);

    const shadowColor = settings.shadowColor || '#000000';
    const shadowOpacity = (settings.shadowOpacity ?? 25) / 100;
    const sr = parseInt(shadowColor.slice(1, 3), 16);
    const sg = parseInt(shadowColor.slice(3, 5), 16);
    const sb = parseInt(shadowColor.slice(5, 7), 16);

    return {
      position: 'fixed',
      top: settings.positionTop !== null && settings.positionTop !== undefined ? `${settings.positionTop}%` : 'auto',
      bottom: settings.positionBottom !== null && settings.positionBottom !== undefined ? `${settings.positionBottom}%` : 'auto',
      left: settings.positionLeft !== null && settings.positionLeft !== undefined ? `${settings.positionLeft}%` : 'auto',
      right: settings.positionRight !== null && settings.positionRight !== undefined ? `${settings.positionRight}%` : 'auto',
      width: pxToVw((settings.iconSize || 60) + (settings.padding || 12) * 2),
      height: pxToVw((settings.iconSize || 60) + (settings.padding || 12) * 2),
      backgroundColor: `rgba(${r}, ${g}, ${b}, ${bgOpacity})`,
      borderRadius: `${settings.borderRadius || 50}%`,
      border: `${pxToVw(settings.borderWidth || 2)} solid ${settings.borderColor || '#0066CC'}`,
      padding: pxToVw(settings.padding || 12),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: `all ${settings.transitionDuration || 0.3}s ease`,
      boxShadow: `${pxToVw(settings.shadowH || 0)} ${pxToVw(settings.shadowV || 4)} ${pxToVw(settings.shadowBlur || 12)} ${pxToVw(settings.shadowSpread || 0)} rgba(${sr}, ${sg}, ${sb}, ${shadowOpacity})`,
      zIndex: 1000,
      userSelect: 'none',
    };
  };

  const getIconStyle = () => ({
    fontSize: pxToVw(settings.iconSize || 60),
    color: isActive ? (settings.iconActiveColor || '#00AA00') : (settings.iconColor || '#0066CC'),
    transition: `color ${settings.transitionDuration || 0.3}s ease`,
  });

  const handleMouseEnter = (e) => {
    e.currentTarget.style.transform = `scale(${settings.hoverScale || 1.1})`;
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.transform = 'scale(1)';
  };

  return (
    <div
      style={getButtonStyle()}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      title={isActive ? 'Wheelchair Mode Active' : 'Activate Wheelchair Mode'}
    >
      {settings.iconType === 'custom' && settings.customIconUrl ? (
        <img
          src={settings.customIconUrl}
          alt="Wheelchair accessibility"
          style={{
            width: pxToVw(settings.iconSize || 60),
            height: pxToVw(settings.iconSize || 60),
            objectFit: 'contain',
            filter: isActive ? 'none' : 'grayscale(50%)',
            transition: `filter ${settings.transitionDuration || 0.3}s ease`,
            borderRadius: `${settings.borderRadius}%`,
          }}
        />
      ) : (
        <AccessibleIcon sx={getIconStyle()} />
      )}
    </div>
  );
};

export default WheelchairToggle;
